import HomeView from './Home.view';
export * from './Home.view';

export const Home = (props) => HomeView(props);

export default Home;

